const permanentStorage = (cache = new Map()) => cache;

export default permanentStorage;
